/* threadkins custom — Gift Mode (Proj 04) behaviour: persistence, counter,
 * confirmation-row state, and the mobile-drawer sheet open logic for
 * snippets/tk-gift-note.liquid (the markup/CSS live there; read its header
 * for the full architecture contract).
 *
 * WHY THIS IS AN ASSET, NOT AN INLINE <script> IN THE SNIPPET (2026-07-19,
 * found via Harry's iPhone): the snippet only renders once the cart has
 * items (cart-summary is absent on an empty cart). A shopper who lands with
 * an EMPTY cart and then adds a product gets the drawer content injected via
 * Section Rendering — and script tags inserted that way NEVER EXECUTE, so
 * the counter froze, the "saved" row never flipped, and typed notes were
 * silently NOT persisted. Loading this file from layout/theme.liquid
 * (defer, next to the tk-tokens/tk-structured-data hook block) guarantees
 * the handlers exist before any cart content does. Everything here is
 * document-delegated + idempotent, so running with zero gift boxes on the
 * page is fine and later-injected markup is picked up automatically.
 */
  (function () {
    if (window.__tkGiftInit) return;
    window.__tkGiftInit = true;

    var UPDATE_URL = (window.Theme && Theme.routes && Theme.routes.cart_update_url) || '/cart/update.js';
    var timers = {};
    var controllers = {};

    function persist(box) {
      var uid = box.getAttribute('data-tk-gift');
      var toggle = box.querySelector('[data-tk-gift-toggle]');
      var msgEl = box.querySelector('[data-tk-gift-msg]');
      var toEl = box.querySelector('[data-tk-gift-to]');
      var fromEl = box.querySelector('[data-tk-gift-from]');
      if (!toggle || !msgEl || !toEl || !fromEl) return;

      var attrs = toggle.checked
        ? { 'Gift order': 'Yes', 'Gift from': fromEl.value, 'Gift to': toEl.value, 'Gift message': msgEl.value }
        : { 'Gift order': '', 'Gift from': '', 'Gift to': '', 'Gift message': '' };

      if (controllers[uid]) controllers[uid].abort();
      var ac = new AbortController();
      controllers[uid] = ac;

      // keepalive:true so an in-flight write survives the checkout navigation
      fetch(UPDATE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs }),
        signal: ac.signal,
        keepalive: true
      }).catch(function () { /* aborted or offline — non-critical, next edit retries */ });
    }

    function flush(box) {
      clearTimeout(timers[box.getAttribute('data-tk-gift')]);
      persist(box);
    }

    function schedule(box, wait) {
      var uid = box.getAttribute('data-tk-gift');
      clearTimeout(timers[uid]);
      timers[uid] = setTimeout(function () { persist(box); }, wait);
    }

    function flushAll() {
      var boxes = document.querySelectorAll('[data-tk-gift]');
      for (var i = 0; i < boxes.length; i++) {
        if (timers[boxes[i].getAttribute('data-tk-gift')]) flush(boxes[i]);
      }
    }

    function updateCounter(el, box) {
      if (!el.matches('[data-tk-gift-msg]')) return;
      var counter = box.querySelector('[data-tk-gift-count]');
      if (counter) {
        counter.textContent = el.value.length + '/' + (el.getAttribute('maxlength') || '300');
      }
    }

    // one edit tick: counter + row state + debounced persist. Idempotent, so the
    // delegated and direct paths below may both fire without harm.
    function onFieldEdit(el, box) {
      updateCounter(el, box);
      syncNote(box);
      schedule(box, 350);
    }

    // confirmation-row state: "Add your gift note" vs "Gift note added · Edit".
    // Server-baked on render; kept live here so the row is honest between renders.
    function syncNote(box) {
      var msgEl = box.querySelector('[data-tk-gift-msg]');
      var toEl = box.querySelector('[data-tk-gift-to]');
      var fromEl = box.querySelector('[data-tk-gift-from]');
      var has = !!(
        (msgEl && msgEl.value.trim()) ||
        (toEl && toEl.value.trim()) ||
        (fromEl && fromEl.value.trim())
      );
      box.classList.toggle('tk-gift--has-note', has);
    }

    // mobile-drawer sheet: open via the DialogComponent wrapper (house pattern —
    // showDialog handles scroll lock, Esc, and the close animation). The
    // customElements.upgrade call closes the not-yet-upgraded race; the raw
    // showModal fallback keeps the sheet usable even if dialog.js never loads.
    function openSheet(box) {
      var wrap = box.querySelector('.tk-gift__sheetwrap');
      if (!wrap) return;
      if (window.customElements && customElements.upgrade) customElements.upgrade(wrap);
      if (typeof wrap.showDialog === 'function') { wrap.showDialog(); return; }
      var dlg = wrap.querySelector('.tk-gift__sheet');
      if (dlg && !dlg.open) dlg.showModal();
    }

    // change — toggle persists immediately; a text field's blur/change commits at once
    // (clicking Checkout blurs the field first, so the last edit is captured pre-navigation)
    document.addEventListener('change', function (e) {
      var el = e.target;
      if (!el || !el.closest) return;
      var box = el.closest('[data-tk-gift]');
      if (!box) return;
      if (el.closest('[data-tk-gift-toggle]')) {
        persist(box);
        // toggle-ON in the DRAWER opens the sheet at every width (2026-07-29;
        // was mobile-only — the desktop inline expand buried the checkout
        // button). Full-screen <=749px, drawer-footprint card >=750px; the
        // presentation split is pure CSS in tk-gift-note.liquid.
        if (el.checked && box.classList.contains('tk-gift--drawer')) {
          openSheet(box);
        }
        return;
      }
      if (el.matches('[data-tk-gift-msg]') || el.matches('[data-tk-gift-to]') || el.matches('[data-tk-gift-from]')) {
        updateCounter(el, box);
        syncNote(box);
        flush(box);
      }
    });

    // from / to / message — debounced persist + live counter + row state
    document.addEventListener('input', function (e) {
      var el = e.target;
      if (!el || !el.closest) return;
      var box = el.closest('[data-tk-gift]');
      if (!box) return;
      if (!el.matches('[data-tk-gift-msg]') && !el.matches('[data-tk-gift-to]') && !el.matches('[data-tk-gift-from]')) return;
      onFieldEdit(el, box);
    });

    // iOS belt-and-braces (2026-07-18/19): on Harry's real iPhone the counter froze
    // and the confirmation row never flipped to "saved" — document-delegated `input`
    // (and possibly `change`) above weren't being delivered for fields inside the
    // top-layer sheet (works fine in desktop engines; delegated CLICKS do deliver).
    // So the moment a gift field gains focus (focusin DOES fire reliably on iOS),
    // bind the edit-tick AND a blur commit DIRECTLY on the node, once. Stable ids +
    // data-skip-node-update mean the node — and its listeners — survive cart morphs;
    // if a morph ever swaps the node, the next focus re-binds. Double-delivery with
    // the delegates is harmless (all idempotent; schedule() debounces; flush aborts
    // any in-flight POST).
    document.addEventListener('focusin', function (e) {
      var el = e.target;
      if (!el || !el.closest || !el.matches) return;
      if (!el.matches('[data-tk-gift-msg]') && !el.matches('[data-tk-gift-to]') && !el.matches('[data-tk-gift-from]')) return;
      if (el.__tkGiftBound) return;
      el.__tkGiftBound = true;
      el.addEventListener('input', function () {
        var box = el.closest('[data-tk-gift]');
        if (box) onFieldEdit(el, box);
      });
      el.addEventListener('blur', function () {
        var box = el.closest('[data-tk-gift]');
        if (box) {
          updateCounter(el, box);
          syncNote(box);
          flush(box);
        }
      });
    });

    // MODAL-STRICT gift sheet (Harry 2026-07-29): the sheet closes ONLY via
    // Done, the ✕, or Esc — never by clicking outside. DialogComponent closes
    // on any click landing outside the panel (assets/dialog.js #handleClick →
    // isClickedOutside), and that ALSO fires when a text-selection drag STARTS
    // inside a field and RELEASES outside: the browser fires the click at the
    // common ancestor of mousedown/mouseup, which for a modal dialog is the
    // <dialog> element itself, with coordinates outside its rect —
    // indistinguishable from a backdrop click, so writing a note and sweeping
    // a selection past the edge silently dismissed the sheet mid-edit.
    // Because the sheet is MODAL, every backdrop/outside/drag-out click has
    // the <dialog> as its direct target (clicks on real controls inside
    // target those controls instead). So: intercept clicks whose direct
    // target is the OPEN gift sheet in CAPTURE on document — DialogComponent's
    // own bubble-phase listener on the wrapper never receives them, and no
    // other behaviour depends on these clicks (the drawer's backdrop script
    // already ignores anything inside a <dialog>). Esc is deliberately kept:
    // it is the keyboard-accessibility convention and loses nothing — every
    // close path flushes the note to cart attributes. Scoped to the GIFT
    // sheet only; the vase sheet keeps its close-to-commit behaviour.
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (t.matches('.tk-gift__sheet[open]')) e.stopPropagation();
    }, true);

    // sheet close — `close` doesn't bubble, so listen in CAPTURE (reaches the
    // target on the way down). Flush is a safety net for Esc-without-blur; also
    // clear the keyboard offset, and defensively close an orphaned sheet if the
    // drawer's own dialog somehow closes around it (normally unreachable — the
    // sheet's modality inerts the drawer).
    document.addEventListener('close', function (e) {
      var t = e.target;
      if (!t || t.nodeType !== 1) return;
      if (t.matches && t.matches('.tk-gift__sheet')) {
        t.style.removeProperty('--tk-kb');
        var box = t.closest('[data-tk-gift]');
        if (box) { syncNote(box); flush(box); }
        return;
      }
      var sheet = t.querySelector && t.querySelector('.tk-gift__sheet[open]');
      if (sheet) { try { sheet.close(); } catch (err) { /* already closed */ } }
    }, true);

    // iOS keyboard: feed the keyboard height to --tk-kb so the sheet's Done
    // footer rides above it (100dvh ignores the keyboard). Degrades gracefully.
    if (window.visualViewport) {
      var tkGiftKb = function () {
        var dlg = document.querySelector('.tk-gift__sheet[open]');
        if (!dlg) return;
        var kb = Math.max(0, window.innerHeight - window.visualViewport.height - window.visualViewport.offsetTop);
        dlg.style.setProperty('--tk-kb', kb + 'px');
      };
      window.visualViewport.addEventListener('resize', tkGiftKb);
      window.visualViewport.addEventListener('scroll', tkGiftKb);
    }

    // commit any pending edit before the page goes away (checkout nav, tab close, app switch)
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') flushAll();
    });
    window.addEventListener('pagehide', flushAll);
  })();
